import { DefaultError, useMutation } from "@tanstack/react-query";
import deleteAdmin, { DeleteAdminParams } from "../api/deleteAdmin";
import { invalidateAdminListQuery } from "../queries/useAdminListQuery";

const useDeleteAdminMutation = (onSuccess: () => void) => {
  return useMutation<unknown, DefaultError, DeleteAdminParams>({
    mutationFn: async (params) => {
      await deleteAdmin(params);
    },
    onSuccess: async () => {
      onSuccess();
      await invalidateAdminListQuery();
    },
    onError: (e) => {
      alert(e.message);
    },
  });
};

export default useDeleteAdminMutation;
